import { TServicesTexts } from '../../en/services';

import History from './history';

const servicesTexts: TServicesTexts = {
  ...History,
};

export default servicesTexts;
